import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ProductService } from 'src/app/market-place/services/product.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'Amarillas-emergencies',
  templateUrl: './emergencies.component.html',
  styleUrls: ['./emergencies.component.scss'],
})
export class EmergenciesComponent implements OnInit {

  listOpts = [];
  loading = true;
  url = environment.url;
  constructor(
    private modalController: ModalController,
    private productsSv: ProductService,
    private navCtrl: NavController
  ) { }

  ngOnInit() {
    this.productsSv.getCategories().subscribe((res: any) => {
      this.listOpts = res.data;
      this.loading = false;
    })
  }

  async goTo(id){
    await this.closeModal();
    this.navCtrl.navigateForward(`/directorios/buscador-negocio/all/1`, { queryParams: { categoria: id } });
  }

  async closeModal(){
    await this.modalController.dismiss();
  }
}
